import { useMutation } from '@tanstack/react-query';
import { type GoodsOption, orderService } from 'shared/src/api';
import { useGoodsOptionsPricing } from './useGoodsOptionsPricing';
import { isNil } from 'shared/src/utils';
import { useIsBottomSheetGiftMode } from '../hooks/useIsBottomSheetGiftMode';

export const useProductCheckout = (selected: GoodsOption[]) => {
  const { data: pricing } = useGoodsOptionsPricing({
    options: selected.map(option => ({
      sno: option.sno,
      count: option.purchase_count ?? 1,
    })),
  });
  const isGiftMode = useIsBottomSheetGiftMode();
  return useMutation({
    throwOnError: false,
    mutationFn: async () => {
      if (isNil(pricing)) return;

      return orderService.postProductCheckout({
        order_type: isGiftMode ? 1 : 0,
        from_ablypay_benefit: false,
        coupon_snos: pricing.coupon_list
          .filter(item => item.item.is_issued)
          .map(coupon => coupon.item.sno),
        goods_options: selected.map(option => ({
          delivery_type: option.delivery_type,
          sno: option.sno,
          text_option: option.message ?? null,
          ea: option.purchase_count ?? 1,
        })),
      });
    },
  });
};
